import React, { FC } from 'react';
import { Box, Text, TextFieldSize, Select, FormControl } from '@bechtel/gds';
import { useField } from 'formik';
import { useLingui } from '@lingui/react';
import { CrewMemberSelectorProps } from './types';
import { useName } from '@bechtel/client-common';
import { t } from '@lingui/macro';

const CrewMemberItem = ({ item }: any) => {
  const { getFullName } = useName();
  return (
    <Text size="400" color="grey.1000">
      {getFullName(item.firstName, item.lastName)}
    </Text>
  );
};

const CrewMemberSelectedItem = ({ item }: any) => {
  const { getFullName } = useName();
  return (
    <Text size="400" color="grey.1000" family="graphik">
      {getFullName(item.firstName, item.lastName)}
    </Text>
  );
};

export const CrewMemberSelector: FC<CrewMemberSelectorProps> = ({ items, fieldName }) => {
  const { i18n } = useLingui();
  const [field, meta, helpers] = useField(fieldName);
  const { setValue } = helpers;
  return (
    <Box flexDirection={{ sm: 'column' }} flexGrow={{ sm: 1 }}>
      <FormControl label={t`Picked by`}>
        <Select
          {...field}
          selectedItem={field.value}
          itemComponent={CrewMemberItem}
          selectedComponent={CrewMemberSelectedItem}
          size={TextFieldSize.LARGE}
          items={items}
          onSelectedItemChange={async (changes) => {
            setValue(changes.selectedItem);
          }}
        />
      </FormControl>
      {meta.touched && meta.error ? (
        <Box pt={{ sm: '200' }}>
          <Text color="bechtel.red">{i18n._(meta.error)}</Text>
        </Box>
      ) : null}
    </Box>
  );
};
